import { TFeature } from '@/shared/types/geojson';
import { MarkerCategory, ShapeLayer } from '@/shared/types/zod';
import { ShapeType } from "@/components/editor/AddShape.vue";
import type { PickedIcon } from "@/data/icons/iconCategories";
import mitt from "mitt"
import { getCurrentInstance, onBeforeUnmount, onMounted } from "vue";


type events = {
	forceSelection: TFeature[],
	forceEdit: { feature: TFeature; append: boolean; },
	addShape: { type: ShapeType, layer: ShapeLayer },
	addMarkerCategory: MarkerCategory,
	addLeg: undefined,
	editIcon: (icon: PickedIcon) => void,
	newRoute: undefined,
	gpxLoaded: undefined,
	routeClicked: undefined,
	closePopup: undefined,
	showPopup: { id: string | number | undefined, fly?: boolean },
	updatePopup: undefined,
	moreInfo: undefined,
	zoomTo: "all" | TFeature | { features: TFeature[], speed?: "normal" | "fast" | "immediate", zoom?: number, offset?: [number, number] },
	paceCalculator: undefined,
	mapSaved: { type: "draft" | "published" }
	mapLoaded: undefined,
	upgradeNotice: undefined
	paddleEvent: any,
}

export function useEventBusListener<K extends keyof events>(event: K, handler: (payload: events[K]) => void) {

	if (getCurrentInstance()?.isMounted) {
		//already mounted, register immediately. Happens when using in onMounted, which should be avoided but... might happen.
		EventBus.on(event, handler);
	} else {
		onMounted(() => {
			EventBus.on(event, handler);
		});
	}

	onBeforeUnmount(() => {
		EventBus.off(event, handler);
	});
}

export const EventBus = mitt<events>();